export default class NetworkingRegion {
  public static readonly SET_LIST = "NETWORKING_REGION_SET_LIST";
  public static readonly SET_STATUS = "NETWORKING_REGION_SET_STATUS";
  public static readonly SET_ERROR = "NETWORKING_REGION_SET_ERROR";
  public static readonly CLEAR = "NETWORKING_REGION_CLEAR";

  public static setList(data: any): any {
    return {
      data,
      type: NetworkingRegion.SET_LIST,
    };
  }

  public static setStatus(data: any): any {
    return {
      data,
      type: NetworkingRegion.SET_STATUS,
    };
  }

  public static setError(data: any): any {
    return {
      data,
      type: NetworkingRegion.SET_ERROR,
    };
  }

  public static clear(): any {
    return {
      type: NetworkingRegion.CLEAR,
    };
  }
}
